import { MachinesPortalState } from 'components/sections/admin-portal/machines/store/use-machines-portal-store';
import { AdminPortalDialog } from 'enums/admin-portal';
import { IAdminMachine } from 'lib_ts/interfaces/i-machine';
import { StateCreator } from 'zustand';

// Note: Open/closed state for the MachineSettingsDialog is managed by useMachineSettingsDialogState, not the MachinesPortalStore.
export type DialogsSlice = {
  dialog?: {
    key: number;
    type: AdminPortalDialog;
    machines: IAdminMachine[]; // used in various AdminPortalDialogs
  };

  openDialog: (params: {
    type: AdminPortalDialog;
    machines?: IAdminMachine[];
  }) => void;

  closeDialog: () => void;
};

type CreateDialogsSlice = StateCreator<
  MachinesPortalState,
  [['zustand/devtools', never]],
  [],
  DialogsSlice
>;

export const createDialogsSlice: CreateDialogsSlice = (set) => ({
  openDialog: ({ type, machines = [] }) => {
    set({
      dialog: {
        // ensures reopening the same dialog type back-to-back works
        key: Date.now(),
        type,
        machines,
      },
    });
  },

  closeDialog: () => {
    set({
      dialog: undefined,
    });
  },
});
